document.addEventListener('rebuy:smartcart.show', (event) => {
    console.log('rebuy:smartcart.show');
    const shopifyChat = document.getElementById('shopify-chat');
    const shopifyForm = document.querySelector('shopify-forms-embed');
    if(shopifyChat) {
        shopifyChat.style.display = 'none';
    }
    if(shopifyForm) {
        shopifyForm.style.display = 'none';
    }
});
document.addEventListener('rebuy:smartcart.hide', (event) => {
    console.log('rebuy:smartcart.hide');
    const shopifyChat = document.getElementById('shopify-chat');
    const shopifyForm = document.querySelector('shopify-forms-embed');
    setTimeout(function() {
        if(!document.getElementById('Details-menu-drawer-container').hasAttribute('open')) {
            if(shopifyChat) {
                shopifyChat.style.display = 'block';
            }
            if(shopifyForm) {
                shopifyForm.style.display = 'block';
            }
        }
    },500);
});